<script>
    import { countryStore } from "../store/Countries.js";
    import VarListEditor from "../SharedComponents/VarListEditor.svelte";
    export let sectionSub;
    import { getContext } from "svelte";
    const { snackbar } = getContext("app");

    $: currentCountryVersion = $countryStore.currentCountryVersion;
    function stopIfPublished() {
        if (currentCountryVersion.isPublished) {
            snackbar("error", "published versions cannot be editted");
            return true;
        }
    }
    async function saveSectionSub(sectionSub) {
        if (stopIfPublished()) {
            window.setTimeout(async ()=>{
                await countryStore.getCountryVersion(sectionSub.countryVersionId);}
            ,100)
            return;
        }

        await countryStore.saveSectionSub(sectionSub);
        await countryStore.getCountryVersion(sectionSub.countryVersionId);
    }
</script>

<div class="row w-100 bg-light">
    <div class="col-4 p-3" on:change={saveSectionSub(sectionSub)}>
        <label for="naam">Naam</label>
        <input
            type="text"
            class="form-control"
            id="naam"
            placeholder="naam van de stap"
            bind:value={sectionSub.nameKey}
            required=""
            disabled={stopIfPublished()}
        />
        <br />
        <label for="sectiontype">Section type</label>
        <select id="sectiontype" bind:value={sectionSub.sectionType}>
        <option value="Factory_Input">Factory Input Section</option>
        <option value="Factory_Summary">Factory Summary Section</option>
        <option value="Product_Input">Product Input Section</option>
        <option value="Product_Summary">Product Summary Section</option>
        </select>
        <!-- <div class="custom-control custom-checkbox mb-3">
            <input
                type="checkbox"
                id="isFactory"
                class="custom-control-input"
                bind:checked={sectionSub.isFactorySection}
                disabled={stopIfPublished()}
            />

            <label for="isFactory" class="custom-control-label">
                is Factory Section
            </label>
        </div>
        <div class="custom-control custom-checkbox mb-3">
            <input
                type="checkbox"
                id="isSummary"
                class="custom-control-input"
                bind:checked={sectionSub.isSummarySection}
                disabled={stopIfPublished()}
            />

            <label for="isSummary" class="custom-control-label">
                is Summary Section
            </label>
        </div> -->
    </div>
    <div class="col-4 p-3">
        <VarListEditor
            bind:VariableList={sectionSub.sectionSubVariables}
            sectionSubId={sectionSub.id}
            on:ListChanged={saveSectionSub(sectionSub)}
        />
    </div>
</div>
